<template>
  <div class="position">
    <template>
      <div
        v-for="widget in widgets"
        :key="widget.id"
        class="widget"
      >
        <div v-if="!widget.hideTitle">
          <h1 class="module-title-light">
            {{ widget.title }}
          </h1>
        </div>
        <template v-if="widget.type == 'menu'">
          <WidgetMenu :menus="widget.menuItems"/>
        </template>
        <template v-else-if="widget.type == 'menu_profile'">
          <MenuProfile/>
        </template>
        <template v-else-if="widget.type == 'page_blog'">
          <PageBlog :widget="widget" :page="widget.page"/>
        </template>
        <template v-else-if="widget.type == 'block'">
          <Block :widget="widget"/>
        </template>
        <div v-else-if="widget.type == 'html'" v-html="widget.content"></div>
        <template v-else>
          <!-- Не задан тип виджета -->
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import WidgetMenu from '@/components/widget/WidgetMenu'
import MenuProfile from '@/components/widget/MenuProfile'
import PageBlog from '@/components/widget/PageBlog'
import Block from '@/components/widget/Block'
import CMS from '@/model/cms'

export default {
  components: {
    WidgetMenu,
    MenuProfile,
    PageBlog,
    Block
  },
  props: {
    position: {
      type: String,
      required: true
    }
  },
  data: () => ({
    widgets: []
  }),
  mounted () {
    CMS.loadWidgetByPosition(this.position)
      .then((response) => {
        this.widgets = response.data
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>
